import { V2Vault } from '@/core/migrate';
import { V2_API_URL, V2_AUTH } from '@/domain/migrate';
import { query } from 'nftx.js';

const fetchV2Vaults = ({ network }: { network: number }) => {
  return query<V2Vault[]>({
    url: `${V2_API_URL}/${network}/vaults`,
    query: { ebn: 'true' },
    headers: {
      Authorization: V2_AUTH,
    },
  });
};

export default fetchV2Vaults;
